var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white echart-container"},[_c('div',{staticStyle:{"width":"960px","height":"204px"},attrs:{"id":"sellAmount"}})])
}]

export { render, staticRenderFns }